module.exports = __webpack_public_path__ + "img/american-burger.f32e1dde.jpg";